module.exports = __webpack_public_path__ + "static/media/xinyi.b5b59431.jpg";